import React from "react";

import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import {Elements, Types} from "components";

import {Button} from "reactstrap";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import {toast} from "react-toastify";

import ReactTable from "react-table";
import PropTypes from "prop-types";
import ImportList from '../Parts/ImportList';
import CollectionOverride from "components/CollectionOverride";
import UniversalModalOverride from "components/UniversalModalOverride";

export default class ProductsExisting extends CollectionOverride {
	static propTypes = {
		...super.propTypes,
		originalType: PropTypes.string,
		requestedLocation: PropTypes.string,
	};

	constructor(props) {
		super(props, Types.Products._name);

		this.searchModel = new API.BuildClass(Types.Products._name, API.RequestType.READ_ALL);
		this.searchModel.limit = null;

		this.state.limit = 10;
		this.limit = 10;

		//Set UI only fields
		this.state.range_start = "";
		this.state.range_end = "";
		this.state.products = [];
		this.state.products_error = "";
		this.state.showImportListModal = false;
		this.state.importListValue = '';
		this.state.importListError = '';


		this.afterSubmit = this.afterSubmit.bind(this);
		this.serialNumberUpdate = this.serialNumberUpdate.bind(this)

		this.request = typeof this.props.status !== 'undefined' ? this.props.status : API.RequestType.READ_ALL;
		if (this.props.originalType && this.props.originalType !== '') {
			this.request = 'GET_TYPE';
			this.model.parent = this.props.originalType;
			this.searchModel.parent = this.props.originalType;
		}
		if (this.props.requestedLocation && this.props.requestedLocation !== '' && this.request === 'GET_IN_STOCK') {
			this.model.parent = this.props.requestedLocation;
			this.searchModel.parent = this.props.requestedLocation;
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if (prevProps.originalType !== this.props.originalType) {
			this.setState({
				search: this.props.originalType
			});
		}
	}

	handleDataChange = event => {
		this.setState({[event.target.name]: event.target.value});
	};

	/**
	 * Return TRUE to prevent handleSubmit from running afterSave(data) if already ran in the override here.
	 * @param data
	 * @param request
	 * @param suppressProcess
	 * @returns {Promise<void>}
	 */
	async afterSubmit(data, request, suppressProcess = false) {
		if (typeof this.props.afterSave !== 'undefined') {
			this.props.afterSave(this.state.products);
		}
	};

	serialNumberUpdate (){
		let start = this.state.range_start.toString();
		let end = this.state.range_end.toString();

		if (start === end) return;
		let min_length = start.length < end.length ? start.length : end.length;
		let match_length = 0;
		let i;

		// If start == end throw a fit
		for (i = 0; i < min_length; i++) {
			if (start.charAt(i) === end.charAt(i)) {
				match_length++;
			} else {
				break;
			}
		}
		for (i = (match_length - 1); i >= 0; i--) {
			if (start.charAt(i).isNumeric()) {
				match_length--;
			} else {
				break;
			}
		}
		let prefix_string = start.substring(0, match_length);
		let start_number = start.substring(match_length);
		let end_number = end.substring(match_length);
		if (!start_number.isNumeric() || !end_number.isNumeric()) {
			toast.warn(Framework.Toast.TitledNotice("Non Matching Sequence", "Serial numbers should match up to the sequential numbers.  If you have serial numbers that do not match use the Individual Serial Numbers section for those."), {
				position: toast.POSITION.TOP_CENTER
			});
			return;
		}

		let required_length = 0;

		let original_start = start_number;
		let original_end = end_number;

		start_number = Number(start_number);
		end_number = Number(end_number);

		if (original_start.length !== start_number.length || original_end.length !== end_number.length) {
			if (original_start.length !== original_end.length) {
				toast.warn(Framework.Toast.TitledNotice("Serial Number's With Leading Zeros", "Start and End Serial Numbers must have the same total length to calculate Serial Numbers with leading Zeros."), {
					position: toast.POSITION.TOP_CENTER
				});
				return;
			}

			required_length = original_start.length;
		}

		if (start_number > end_number) {
			toast.warn(Framework.Toast.TitledNotice("Serial Number Order", "Start Serial Number can not be greater than the End Serial Number."), {
				position: toast.POSITION.TOP_CENTER
			});
			return;
		}

		let serial_numbers = [];
		for (; start_number <= end_number; start_number++) {
			let calculated_number = prefix_string + start_number.padUntil(required_length);
			serial_numbers.push(calculated_number);
		}

		serial_numbers = [...new Set(serial_numbers)];

		if(serial_numbers.length <= 10){
			this.searchModel.object.serial_numbers = serial_numbers;
		}
		else{
			this.searchModel.object.serial_numbers = prefix_string + "|" + original_start + "|" + original_end;
		}
		this.searchModel.submit(null, this.request).then((products) => {
			if (products.items.length === 0) {
				toast.warn(Framework.Toast.TitledNotice("No Products Found", "No products where found for the Serial Number range."), {
					position: toast.POSITION.TOP_CENTER
				});
			} else {
				this.setState({
					products: [ ...products.items],
					products_error: ""
				});
			}
		});

	};

	addSerialNumber = (e) => {
		const {data, products} = this.state;
		const pkey = parseInt(e.currentTarget.id);
		const binary_id = e.currentTarget.getAttribute('binary_id');
		let found = products.find((entry) => entry.pkey === pkey && entry.binary_id === binary_id);

		if (!found) {
			const product = data.find((entry) => entry.pkey === pkey && entry.binary_id === binary_id);

			if (product) {
				products.push(product);

				this.setState({
					products,
					products_error: ""
				});
			}
		} else {
			this.setState({
				products_error: "Product already in list.",
			});
		}
	};

	removeSerialNumber = (e) => {
		const {products} = this.state;
		const pkey = parseInt(e.currentTarget.id);
		const binary_id = e.currentTarget.getAttribute('binary_id');
		const existingProductIndex = products.findIndex((entry) => entry.pkey === pkey && entry.binary_id === binary_id);

		if (existingProductIndex > -1) {
			products.splice(existingProductIndex, 1);
		}

		this.setState({
			products,
			products_error: '',
		});
	};

	handleImportListClick = () => {
		let {showImportListModal} = this.state;
		this.setState({showImportListModal: !showImportListModal});
	}

	handleImportListChange = (importListValue) => {
		let {serial_numbers} = this.state;
		let lines;

		if (!importListValue.length || importListValue === ' ' || importListValue === '') {
			this.setState({importListError: 'Serial number list cannot be blank.'});
			return;
		}

		lines = importListValue.split(/[,\n]/)
			.map((line) => line.trim());

		serial_numbers = [...new Set(lines)];
		serial_numbers = serial_numbers.filter(function (el) {
			return el != null && el.trim() !== '';
		});

		let looping = 1;
		if(serial_numbers.length >= 10){
			looping = Math.ceil(serial_numbers.length / 10);
		}
		for(let i=1;i<=looping;i++) {
			this.searchModel.object.serial_numbers = serial_numbers.slice(((i-1)*10), (i*10));
			this.searchModel.submit(null, this.request).then((products) => {
				if (products.items.length === 0) {
					toast.warn(Framework.Toast.TitledNotice("No Products Found", "No products where found for the Serial Number range."), {
						position: toast.POSITION.TOP_CENTER
					});
				} else {
					this.setState({
						products: [...this.state.products, ...products.items],
						products_error: ""
					});
				}
			});
		}
	}

	table = () => {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<Button
							id={props.original.pkey}
							binary_id={props.original.binary_id}
							data-id={"product-"+props.original.serial_number}
							color="blue-hoki"
							size={"sm"}
							block={true}
							onClick={this.addSerialNumber}>
							<i className={"fa fa-plus"}/>
						</Button>
					);
				}
			},
			{
				Header: "ID",
				id: "pkey",
				accessor: obj => (obj.id ? obj.id : obj.pkey)
			},
			{
				Header: "Manufacturer",
				id: 'manufacturer',
				/** @param {Products_Object} obj */
				accessor: obj => (obj.manufacturer ? obj.manufacturers.name : obj.manufacturer_other)
			},
			{
				Header: "Model",
				accessor: "model",
			},
			{
				Header: "Serial",
				accessor: "serial_number",
			},
			{
				Header: "Type",
				accessor: "type",
			},
			{
				Header: "Location",
				id: "location",
				accessor: obj => (obj.locations && obj.status === 1 ? obj.locations.name : "Not In Stock")
			},
			{
				Header: "Status",
				id: 'status',
				/** @param {Products_Object} obj */
				accessor: obj => (obj.status ? obj.product_statuses.name : "Never Acquired")
			},
		];

		return (
			<div>
				<div className={"row"}>
					<div className={"col-md-8"}>
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('Products', "")}
								{this.renderHeaderRight('Products', columns)}

							</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							onPageSizeChange={this.onPageSizeChange}
							onSortedChange={this.onSortedChange}
							page={this.state.page}
							onPageChange={this.onPageChange}
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={true}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							defaultPageSize={limit}
							pageSize={limit}
							pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
							className="-striped -highlight"
						/>
					</div>
					<div className={"col-md-4"}>
						{/*#region Sequential Serial Numbers*/}
						<div className="section-title">
							<h4 className="section-title">Sequential Serial Numbers</h4>
							<Button color="info" onClick={this.handleImportListClick}>Import List</Button>
						</div>
						<div className="form-group">
							<div className={"row"}>
								<div className={"col-md-4 pr-0"}>
									<TextField
										fullWidth
										margin="dense"
										variant="outlined"
										name="range_start"
										label="Start Range"
										value={this.state.range_start}
										onChange={this.handleDataChange}
										size="small"
									/>
								</div>
								<div className={"col-md-4 pr-0"}>
									<TextField
										fullWidth
										margin="dense"
										variant="outlined"
										name="range_end"
										label="End Range"
										value={this.state.range_end}
										onChange={this.handleDataChange}
										size="small"
									/>
								</div>
								<div className={"col-md-4 text-right"}>
									<Button data-id={'seq-sn-calculate'} size={"md"} color="green-meadow" onClick={this.serialNumberUpdate}>
										Calculate
									</Button>
								</div>
							</div>
						</div>
						{/*#endregion*/}
						{/*#region Selected Product(s)*/}
						<h4 className="section-title">Selected Product(s)</h4>
						<div style={{"maxHeight": "338px", "overflowY": "scroll", "paddingRight": "4px"}}>
							{this.state.products_error &&
							<div style={{
								"padding": "0px 4px 4px",
								"fontStyle": "italic",
								"fontSize": "12px",
								"color": "#ef534f",
								"textAlign": "center"
							}}>
								{this.state.products_error}
							</div>
							}
							{this.state.importListError &&
							<div style={{
								"padding": "0px 4px 4px",
								"fontStyle": "italic",
								"fontSize": "12px",
								"color": "#ef534f",
								"textAlign": "center"
							}}>
								{this.state.importListError}
							</div>
							}
							{this.state.products.map((product, i) => {
								return (
									<Elements.ItemLookup
										key={i}
										product={product}
										remove={this.removeSerialNumber}/>
								);
							})}
						</div>
						{/*#endregion*/}
					</div>
				</div>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					history={this.props.history}
					name={"Import List of Serial Numbers"}
					object={ImportList}
					showModal={this.state.showImportListModal}
					handleToggle={this.handleImportListClick}
					afterSave={this.handleImportListChange}
					afterSubmit={() => {}}
				/>
			</div>
		)
	};

	render() {
		let hasModal = typeof this.props.hasModal !== 'undefined' ? this.props.hasModal : false;
		if (hasModal) {
			return this.table();
		}
		return (
			<Card>
				<CardContent>
					{this.table()}
				</CardContent>
			</Card>
		)
	}
}
